$('button#download').on('click', function () {
    event.preventDefault();
    let btn = $(this);
    let url = btn.data('url');

    let form = $('<form action="' + url + '" method="post"></form>').hide();
    let cks = $('[type="checkbox"].note:checked');
    if (cks.length == 0) {
        alert("Selecione um registro para continuar.");
        return;
    }
    cks.each(function (indx, element) {
        form.append($('<input type="hidden" name="note[]">').val($(element).val()));
    });
    let formToken = $('meta[name="csrf-token"]').attr('content');
    let input1 = $('<input type="hidden" name="_token">').val(formToken);
    form.append(input1).appendTo('body').submit();
});

$('button#email').on('click', function () {
    event.preventDefault();
    let btn = $(this);
    let url = btn.data('url');

    let form = $('<form action="' + url + '" method="post"></form>').hide();
    let cks = $('[type="checkbox"].note:checked');
    if (cks.length == 0) {
        alert("Selecione um registro para continuar.");
        return;
    }
    cks.each(function (indx, element) {
        form.append($('<input type="hidden" name="note[]">').val($(element).val()));
    });
    let formToken = $('meta[name="csrf-token"]').attr('content');
    let input1 = $('<input type="hidden" name="_token">').val(formToken);
    let emailInp = $('[type="email"]');

    if (!emailInp.val()) {
        alert("O campo email esta vazio.");
        return;
    }

    form.append(input1, emailInp).appendTo('body').submit();
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-nf-actions.js